

import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"
import { IntegrationColumn, IntegrationSettings } from "@/types/integration"
import { Field } from "@/types"
import { CaseColumn } from "@/types/caseColumns"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class FieldMapping extends Vue {
	@Prop()
	value!: { [key: string]: string }

	@Prop({ default: () => [] })
	fields!: IntegrationColumn[];

	@Prop({ default: () => [] })
	casesFields!: Field[];

	@Prop({ default: () => [] })
	caseColumns!: CaseColumn[]

	@Prop()
	createField!: (field: IntegrationColumn) => Promise<Field>

	@Prop({ default: true })
	allowCreateFields!: boolean

	mounted () {
		if (!this.value) {
			this.$emit("input", {})
		}
	}

	matchingFields (field: IntegrationColumn): Field[] {
		return this.casesFields.filter(f => f.dataType === field.dataType)
	}

	matchingColumns (field: IntegrationColumn): CaseColumn[] {
		return this.caseColumns.filter(f => f.dataType === field.dataType)
	}

	fieldValueSet (field: IntegrationColumn, fieldId: string) {
		this.$emit("input", {
			...this.value,
			[field.key]: fieldId
		})
	}

	async createNewField (field: IntegrationColumn) {
		const fieldId = await this.createField(field)
		this.$emit("input", {
			...this.value,
			[field.key]: fieldId
		})
	}
}

